import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { AdminCarReservationPrivateRoute, AdminTrainingPrivateRoute, MyCarReservationPrivateRoute, PrivateRoute, PublicRoute } from './routePermission'

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})
const LayoutTracker = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutTracker'),
})


//Features


const TrackerController = LoadableRoute({
    loader: () => import('../components/features/tracker/home/controllers/trackerController'),
})
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})
const bypassLoginController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/bypassLoginController'),
})

const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
})

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/tracker/home/controllers/homeController'),
})

// Info
const InfoController = LoadableRoute({
    loader: () => import('../components/features/tracker/info/controllers/infoController'),
})

// Task List 
const TaskListController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/list/controllers/taskListController'),
})

const MyTaskListController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/list/controllers/myTaskListController'),
})

const MyDraftListController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/list/controllers/myDraftListController'),
})

// Create Task  
const CreateTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/create/controllers/createTaskController'),
})

// View Draft Task  
const ViewDraftTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/view/controllers/viewDraftTaskController'),
})

// View My Task  
const ViewMyTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/view/controllers/viewMyTaskController'),
})

// View Assign Task  
const ViewAssignTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/view/controllers/viewAssignTaskController'),
})

// Comment Controller
const CommentController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/comment/controllers/commentController'),
})


// User Info
const UserInfoController = LoadableRoute({
    loader: () => import('../components/features/tracker/userinfo/controllers/userController'),
})
// Update OilPrice
const UpdateOilPRiceController = LoadableRoute({
    loader: () => import('../components/features/tracker/oilPrice/controllers/realtimeOilPrice'),
})

// UpdateTask Controller
const UpdateTaskController = LoadableRoute({
    loader: () => import('../components/features/tracker/taskList/update/controllers/updateController'),
})

const PrompayQRController = LoadableRoute({
    loader: () => import('../components/features/prompayQR/controllers/prompayQRController'),

})

//Settings

const MasterDataController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/landingMenu/controllers/masterDataController'),
})
const ReportController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/landingMenu/controllers/reportController'),
})
// User Group
const ListUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/listUserGroupsController'),
})

const CreateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/createUserGroupsController'),
})

const UpdateUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/updateUserGroupsController'),
})

const ViewUserGroupController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/userGroup/controllers/viewUserGroupsController'),
})

// Flow
const ListFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/listFlowsController'),
})

const CreateFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/createFlowsController'),
})

const UpdateFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/updateFlowsController'),
})

const ViewFlowController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/flow/controllers/viewFlowsController'),
})

// Course Type
const ListCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/listCourseTypeController'),
})

const CreateCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/createCourseTypeController'),
})

const UpdateCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/updateCourseTypeController'),
})

const ViewCourseTypeController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/courseType/controllers/viewCourseTypeController'),
})


// Course 

const ListCourseWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseWaitingApproveController'),
})

const DetailCourseWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/detailCourseWaitingApproveController'),
})

const ListCourseWaitingRequestController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseWaitingRequestController'),
})

const DetailCourseWaitingRequestController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/detailCourseWaitingRequestController'),
})

const ScoreCertCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/scoreCertCourseController'),
})

const ListCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseController'),
})

const CreateCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/createCourseController'),
})

const UpdateCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/updateCourseController'),
})

const ViewCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/viewCourseController'),
})


// Course History

const ListCourseHistoryWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseHistoryWaitingApproveController'),
})


const DetailCourseHistoryWaitingApproveController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/detailCourseHistoryWaitingApproveController'),
})


const ScoreCertCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/scoreCertCourseHistoryController'),
})

const ListCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/listCourseHistoryController'),
})

const CreateCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/createCourseHistoryController'),
})

const UpdateCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/updateCourseHistoryController'),
})

const ViewCourseHistoryController = LoadableRoute({
    loader: () => import('../components/features/hr/settings/course/controllers/viewCourseHistoryController'),
})




// Landing Page for Hr Module
const HrModuleHome = LoadableRoute({
    loader: () => import('../components/features/hr/home/controllers/hrModuleHomeController'),
})

const MyCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/myCourse/controllers/listMyCourseController'),
})

const MyCertController = LoadableRoute({
    loader: () => import('../components/features/hr/myCert/controllers/listMyCertController'),
})

//Report
const ReportCourseController = LoadableRoute({
    loader: () => import('../components/features/hr/report/controllers/reportCourseController'),
})


// Car Reservervation
// Car Type
const ListCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/carType/list/controllers/listCarTypeController'),
})

const CreateCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/carType/create/controllers/createCarTypeController'),
})

const UpdateCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/carType/update/controllers/updateCarTypeController'),
})

const ViewCarTypeController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/carType/view/controllers/viewCarTypeController'),
})
// User Group
const ListCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/userGroup/controllers/listUserGroupsController'),
})

const CreateCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/userGroup/controllers/createUserGroupsController'),
})

const UpdateCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/userGroup/controllers/updateUserGroupsController'),
})

const ViewCarRUserGroupController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/userGroup/controllers/viewUserGroupsController'),
})
// Car
const ListRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/car/list/controllers/listCarController'),
})

const CreateRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/car/create/controllers/createCarController'),
})

const UpdateRCarController = LoadableRoute({
    // loader: () => import('../components/features/carReserve/masterData/car/update/controllers/upateCarController'),
})

const ViewRCarController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/car/view/controllers/viewCarController'),
})
// Car Driver
const GetCarDriverController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/carDriver/view/controllers/getCarDriverController'),
})
const UpdateCarDriverController = LoadableRoute({
    loader: () => import('../components/features/carReserve/masterData/carDriver/update/controllers/updateCarDriverController'),
})


export default () => (
    <Switch>

        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/carDriver/update' component={UpdateCarDriverController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/carDriver' component={GetCarDriverController} layout={LayoutMaster} />


        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/car/view/:id' component={ViewRCarController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/car/update/:id' component={UpdateRCarController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/car/create' component={CreateRCarController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/car' component={ListRCarController} layout={LayoutMaster} />


        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/userGroup/view/:id' component={ViewCarRUserGroupController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/userGroup/update/:id' component={UpdateCarRUserGroupController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/userGroup/create' component={CreateCarRUserGroupController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/userGroup' component={ListCarRUserGroupController} layout={LayoutMaster} />


        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/carType/view/:id' component={ViewCarTypeController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/carType/update/:id' component={UpdateCarTypeController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/carType/create' component={CreateCarTypeController} layout={LayoutMaster} />
        <AdminCarReservationPrivateRoute path='/carReserve/masterdata/carType' component={ListCarTypeController} layout={LayoutMaster} />


        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/view/:id/:active' component={ViewCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/view/:id' component={ViewCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/update/:id' component={UpdateCourseHistoryController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/scoreCert/:id' component={ScoreCertCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/waitingapprove/:id' component={DetailCourseHistoryWaitingApproveController} layout={LayoutMaster} />


        <AdminTrainingPrivateRoute path='/training/masterdata/course/view/:id/:active' component={ViewCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/update/:id' component={UpdateCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/view/:id' component={ViewCourseController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/training/masterdata/course/scoreCert/:id' component={ScoreCertCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/waitingrequest/:id' component={DetailCourseWaitingRequestController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/waitingapprove/:id' component={DetailCourseWaitingApproveController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/waitingapprove' component={ListCourseHistoryWaitingApproveController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/training/masterdata/course/history/create' component={CreateCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/create' component={CreateCourseController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/waitingrequest' component={ListCourseWaitingRequestController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course/waitingapprove' component={ListCourseWaitingApproveController} layout={LayoutMaster} />


        <AdminTrainingPrivateRoute path='/training/masterdata/coursetype/update/:id' component={UpdateCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/coursetype/view/:id' component={ViewCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/coursetype/create' component={CreateCourseTypeController} layout={LayoutMaster} />


        <AdminTrainingPrivateRoute path='/training/masterdata/flow/update/:id' component={UpdateFlowController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/flow/view/:id' component={ViewFlowController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/flow/create' component={CreateFlowController} layout={LayoutMaster} />


        <AdminTrainingPrivateRoute path='/training/masterdata/usergroups/update/:id' component={UpdateUserGroupController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/usergroups/view/:id' component={ViewUserGroupController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/usergroups/create' component={CreateUserGroupController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/training/masterdata/course/history' component={ListCourseHistoryController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/course' component={ListCourseController} layout={LayoutMaster} />

        <AdminTrainingPrivateRoute path='/training/masterdata/coursetype' component={ListCourseTypeController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/flow' component={ListFlowController} layout={LayoutMaster} />
        <AdminTrainingPrivateRoute path='/training/masterdata/usergroups' component={ListUserGroupController} layout={LayoutMaster} />


        <PrivateRoute path='/comment/:taskM/:id' component={CommentController} layout={LayoutTracker} />
        <PrivateRoute path='/draft/view/:id' component={ViewDraftTaskController} layout={LayoutTracker} />
        <PrivateRoute path='/mytask/view/:id' component={ViewMyTaskController} layout={LayoutTracker} />
        <PrivateRoute path='/assingtask/view/:id' component={ViewAssignTaskController} layout={LayoutTracker} />


        <PrivateRoute path='/task/create' component={CreateTaskController} layout={LayoutTracker} />
        <PrivateRoute path='/update/:id' component={UpdateTaskController} layout={LayoutTracker} />

        <PrivateRoute exact path='/crshome/myCourse' component={MyCourseController} layout={LayoutTracker} />
        <PrivateRoute exact path='/crshome/history' component={MyCertController} layout={LayoutTracker} />


        <PrivateRoute path='/report/course' component={ReportCourseController} layout={LayoutMaster} />
        <PrivateRoute path='/report' component={ReportController} layout={LayoutMaster} />
        <PrivateRoute exact path='/masterdata' component={MasterDataController} layout={LayoutMaster} />

        <PrivateRoute path='/info' component={InfoController} layout={LayoutTracker} />

        <PrivateRoute path='/userinfo' component={UserInfoController} layout={LayoutTracker} />
        <PrivateRoute path='/draft' component={MyDraftListController} layout={LayoutTracker} />
        <PrivateRoute path='/mytask' component={MyTaskListController} layout={LayoutTracker} />
        <PrivateRoute path='/tasklist' component={TaskListController} layout={LayoutTracker} />

        <PrivateRoute path='/oil' component={UpdateOilPRiceController} layout={LayoutTracker} />

        {/* <PublicRoute exact path='/' component={HomeController} layout={LayoutTracker} /> */}

        <PrivateRoute exact path='/crshome' component={HrModuleHome} layout={LayoutBlank} />
        <PrivateRoute exact path='/prompayqr' component={PrompayQRController} layout={LayoutTracker} />
        <PrivateRoute exact path='/tckhome' component={TrackerController} layout={LayoutTracker} />
        <PrivateRoute exact path='/' component={HomeController} layout={LayoutBlank} />

        <PublicRoute path='/unauthen' component={UnAuthenController} layout={LayoutMaster} />
        <PublicRoute path='/login' component={Login} layout={LayoutBlank} />
        <PublicRoute path='/bypass/:base64' component={bypassLoginController} layout={LayoutBlank} />

        <PublicRoute component={NotFoundController} layout={LayoutTracker} />

    </Switch>
)


// WEBPACK FOOTER //
// ./src/app/routes/Routes.js